var sc = sc || {};
sc.alpine = sc.alpine || {};

window.sc.alpine.select = function (config) {
    return {
        data: config.data,

        emptyOptionsMessage: config.emptyOptionsMessage ?? 'No results match your search.',

        focusedOptionIndex: null,

        name: config.name,

        open: false,

        loadingMessage: false,

        options: [],

        placeholder: config.placeholder ?? 'Select an option',

        search: '',

        value: config.value ?? 0,

        loadingImage: false,

        selectedText: config.selectedText,

        fetchUrl: config.fetchUrl ?? null,

        closeListbox: function () {
            this.open = false

            this.focusedOptionIndex = null

            this.search = ''
        },

        focusNextOption: function () {
            if (this.focusedOptionIndex === null) return this.focusedOptionIndex = Object.keys(this.options).length - 1

            if (this.focusedOptionIndex + 1 >= Object.keys(this.options).length) return

            this.focusedOptionIndex++

            this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
                block: "center",
            })
        },

        focusPreviousOption: function () {
            if (this.focusedOptionIndex === null) return this.focusedOptionIndex = 0

            if (this.focusedOptionIndex <= 0) return

            this.focusedOptionIndex--

            this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
                block: "center",
            })
        },

        init: function () {
            this.options = this.data

            if (this.fetchUrl != "") {
                for (var i = 0; i < this.options.length; i++) {
                    if (this.options[i].key == this.value) {
                        this.selectedText = this.options.find(element => element.key === this.value).value;
                        break;
                    }
                }
            }

            if (this.selectedText == null || this.selectedText == "" || this.selectedText == " ") {
                this.value = null;
                this.selectedText = this.placeholder;
            };

            this.$watch('search', ((value) => {

                if (this.fetchUrl === "") {
                    if (!this.open || !value) return this.options = this.data

                    this.options = this.data.filter(function (el) {
                        return el.value.toLowerCase().includes(value.toLowerCase())
                    });
                }
                else {


                    if (value.length > 0) {

                        this.emptyOptionsMessage = "";
                        this.loadingImage = true;
                    }

                    fetch(this.fetchUrl.concat(value))
                        .then(response => response.json())
                        .then(data => {
                            this.loadingImage = false;
                            this.options = data;
                            this.emptyOptionsMessage = config.emptyOptionsMessage ?? 'No results match your search.';
                        });


                }

            }))
        },

        selectOption: function () {
            if (!this.open) return this.toggleListboxVisibility()

            this.value = this.options[this.focusedOptionIndex].key;

            this.selectedText = this.options[this.focusedOptionIndex].value;

            this.closeListbox()
        },

        toggleListboxVisibility: function () {
            /*if (this.open) return this.closeListbox()*/

            this.focusedOptionIndex = Object.keys(this.options).indexOf(this.value)

            if (this.focusedOptionIndex < 0) this.focusedOptionIndex = 0

            this.open = true

            this.$nextTick(() => {
                setTimeout(() => this.$refs.search.focus(), 50);

                this.$refs.listbox.children[this.focusedOptionIndex].scrollIntoView({
                    block: "center"
                })
            })
        },
    }
}